import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import 'bootstrap';
require('./bootstrap');
require('./toasts');
require('./qrcode-scan');
require('./air-datepicker/dist/js/datepicker');
require('./air-datepicker/dist/js/i18n/datepicker.en');

jQuery(document).ready(function() {
    jQuery.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    jQuery('select.chosen').chosen({
            "allow_single_deselect": true
    });

    initDatepicker();

    jQuery('[data-toggle="tooltip"]').tooltip();

    jQuery('.lightbox').tossnLightbox();
});

window.showWaitbox = function() {
    $('#waitbox').addClass('visible');
};

window.hideWaitbox = function() {
    $('#waitbox').removeClass('visible');
};

function fadeOutDissmissableAlerts() {
    var dismissableAlertButtons = jQuery('[data-dismiss="alert"]');
    if (dismissableAlertButtons.length > 0) {
        dismissableAlertButtons.each(function() {
            var alertBox = jQuery(this).parent('.alert');
            window.setTimeout(function() {
                alertBox.fadeOut();
            }, 3000);
        });
    }
}

function initDatepicker() {
    jQuery('.date-picker').datepicker({
        language: 'en',
        dateFormat: 'dd.mm.yyyy',
        timepicker: false,
        firstDay: 1
    });
    jQuery('.date-time-picker').datepicker({
        language: 'en',
        dateFormat: 'dd.mm.yyyy',
        timeFormat: 'hh:ii',
        timepicker: true,
        firstDay: 1
    });
}

window.getFormData = function(form) {
    var formData = {};
    var inputs = jQuery(form).serializeArray();
    jQuery.each(inputs, function (i, input) {
        formData[input.name] = input.value;
    });

    return formData;
};


window.uploaderAlert = function(text, type) {
    var TostInstance = new window.toast({
        'text': text,
        'cssClass': 'toast-' + type,
        'duration': 2000
    });
    TostInstance.open();
};

window.triggerUploaderProgressBar = function(field, id, progress) {
    var container = jQuery(field).parent('div');
    if (jQuery(container).children('.progress[data-id="' + id + '"]').length === 0) {
        jQuery(container).append(jQuery('<div />', {
            class: 'progress',
            'data-id': id
        }));
    }
    else {
        jQuery(container).children('.progress[data-id="' + id + '"]').html('');
    }

    jQuery(container).children('.progress[data-id="' + id + '"]').append(jQuery('<div />', {
        class: 'progress-bar progress-bar-striped progress-bar-animated active',
        role: 'progressbar',
        "aria-valuenow": progress,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        css: {
            width: progress + '%'
        }
    }));
};

window.markUploaderProgressBar = function(field, id, type) {
    var progressBar = jQuery(field).parent('div').children('.progress[data-id="' + id + '"]').children('.progress-bar');
    jQuery(progressBar).removeClass('active');
    jQuery(progressBar).addClass('bg-' + type);
};

window.removeProgressBar = function(id) {
    jQuery('.progress[data-id="' + id + '"]').fadeOut();
};

window.uploaderPreviewImage = function(field, fileBase64Src, id, isSingleupload) {
    var previewContainer = getUploaderPreviewContainer(field);

    if (isSingleupload) {
        jQuery(previewContainer).children('.upload-preview').remove();
    }

    var img = jQuery('<img />', {
        class: 'upload-preview-image',
        src: fileBase64Src
    });
    var uploadPreview = jQuery('<div />', {
        class: 'upload-preview',
        'data-id': id
    });

    uploadPreview.append(getRemoveUploadedFileButton(id, isSingleupload));
    uploadPreview.append(getDownloadUploadedFileButton(id));
    uploadPreview.append(img);
    jQuery(previewContainer).append(uploadPreview);
};

window.uploaderPreviewFile = function(field, fileName, id, isSingleupload) {
    var previewContainer = getUploaderPreviewContainer(field);

    if (isSingleupload) {
        jQuery(previewContainer).children('.upload-preview').remove();
    }

    var div = jQuery('<div />', {
        class: 'upload-preview-div',
        html: fileName
    });
    var uploadPreview = jQuery('<div />', {
        class: 'upload-preview',
        'data-id': id
    });

    uploadPreview.append(getRemoveUploadedFileButton(id, isSingleupload));
    uploadPreview.append(getDownloadUploadedFileButton(id));
    uploadPreview.append(div);
    jQuery(previewContainer).append(uploadPreview);
};

window.getRemoveUploadedFileButton = function(id, isSingleupload) {
    return jQuery('<button />', {
        type: 'button',
        html: '&times;',
        click: function() {
            removeUploadedFile(jQuery(this), id, isSingleupload);
        },
        class: 'btn btn-danger btn-sm upload-preview-close'
    });
};

window.getDownloadUploadedFileButton = function(id) {
    return jQuery('<a />', {
        href: '#',
        click: function(event) {
            event.preventDefault();
            window.open('/file-download/' + jQuery('input[type="hidden"][data-id="' + id + '"]').val());
        },
        title: 'download',
        html: '<span class="fa fa-download"></span>',
        class: 'btn btn-sm btn-primary download-uploaded-file'
    });
};

window.getUploaderPreviewContainer = function(field) {
    if (jQuery(field).parent('div').children('.upload-preview-container').length === 0) {
        jQuery(field).parent('div').prepend(jQuery('<div />', {
            class: 'upload-preview-container'
        }));
    }

    return jQuery(field).parent('div').children('.upload-preview-container:first');
};

window.removeUploadedFile = function(link, id, isSingleupload) {
    if (isSingleupload) {
        link.parent().parent().nextAll('input[type="hidden"]').val('').attr('data-id', '');
    }
    else {
        link.parent().parent().nextAll('[data-id="' + id + '"]').remove();
    }

    if (link.parent().parent().children('.upload-preview').length === 1) {
        link.parent().parent().remove();
    }
    else {
        link.parent('[data-id="' + id + '"').remove();
    }
};